module.exports = __webpack_public_path__ + "media/images/landing/avatar9-9131a05430b3541a59602f5af87282b5.jpg";